import { gql } from '@apollo/client';

// ── createPaymentIntent ─────────────────────────────────────────────────────

export const CREATE_PAYMENT_INTENT_MUTATION = gql`
  mutation CreatePaymentIntent($input: CreatePaymentIntentInput!) {
    createPaymentIntent(input: $input) {
      success
      message
      clientSecret
      snapshotId
      breakdown {
        serviceAmount
        taxAmount
        taxType
        taxRate
        province
        applicationFee
        platformFee
        stripeFee
        total
        currency
      }
    }
  }
`;

// ── verifyPaymentReturn ─────────────────────────────────────────────────────

export const VERIFY_PAYMENT_RETURN_MUTATION = gql`
  mutation VerifyPaymentReturn($snapshotId: String!) {
    verifyPaymentReturn(snapshotId: $snapshotId) {
      success
      message
      status
      bookingRef
      clientSecret
    }
  }
`;

// ── getPaymentStatus (polling) ──────────────────────────────────────────────

export const GET_PAYMENT_STATUS_QUERY = gql`
  query GetPaymentStatus($snapshotId: String!) {
    getPaymentStatus(snapshotId: $snapshotId) {
      success
      message
      status
      bookingRef
      totalAmount
    }
  }
`;

// ── createCheckoutSession ───────────────────────────────────────────────────

export const CREATE_CHECKOUT_SESSION_MUTATION = gql`
  mutation CreateCheckoutSession($input: CreateCheckoutSessionInput!) {
    createCheckoutSession(input: $input) {
      success
      message
      sessionId
      url
      snapshotId
      breakdown {
        serviceAmount
        taxAmount
        taxType
        taxRate
        province
        applicationFee
        platformFee
        stripeFee
        total
        currency
      }
    }
  }
`;

// ── verifyCheckoutSessionReturn ─────────────────────────────────────────────

export const VERIFY_CHECKOUT_SESSION_RETURN_MUTATION = gql`
  mutation VerifyCheckoutSessionReturn($snapshotId: String!) {
    verifyCheckoutSessionReturn(snapshotId: $snapshotId) {
      success
      message
      status
      bookingRef
    }
  }
`;

// ── cancelPaymentIntent ─────────────────────────────────────────────────────

export const CANCEL_PAYMENT_INTENT_MUTATION = gql`
  mutation CancelPaymentIntent($snapshotId: String!) {
    cancelPaymentIntent(snapshotId: $snapshotId) {
      success
      message
    }
  }
`;

// ── initiateRefund (owner / employee only) ──────────────────────────────────

export const INITIATE_REFUND_MUTATION = gql`
  mutation InitiateRefund($input: InitiateRefundInput!) {
    initiateRefund(input: $input) {
      success
      message
      refundAmount
      stripeRefundId
    }
  }
`;

// ── getTaxRates ─────────────────────────────────────────────────────────────

export const GET_TAX_RATES_QUERY = gql`
  query GetTaxRates {
    getTaxRates {
      province
      provinceName
      taxType
      totalRate
    }
  }
`;

// ── Response shapes (for Apollo useMutation/useQuery generics) ──────────────

import type {
  CancelPaymentIntentResult,
  CreatePaymentIntentResult,
  CreateCheckoutSessionResult,
  GetPaymentStatusResult,
  InitiateRefundResult,
  TaxRate,
  VerifyCheckoutSessionReturnResult,
  VerifyPaymentReturnResult,
} from './payment.types';

export interface CreatePaymentIntentResponse {
  createPaymentIntent: CreatePaymentIntentResult;
}
export interface VerifyPaymentReturnResponse {
  verifyPaymentReturn: VerifyPaymentReturnResult;
}
export interface GetPaymentStatusResponse {
  getPaymentStatus: GetPaymentStatusResult;
}
export interface CancelPaymentIntentResponse {
  cancelPaymentIntent: CancelPaymentIntentResult;
}
export interface InitiateRefundResponse {
  initiateRefund: InitiateRefundResult;
}
export interface GetTaxRatesResponse {
  getTaxRates: TaxRate[];
}
export interface CreateCheckoutSessionResponse {
  createCheckoutSession: CreateCheckoutSessionResult;
}
export interface VerifyCheckoutSessionReturnResponse {
  verifyCheckoutSessionReturn: VerifyCheckoutSessionReturnResult;
}
